module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "dialog-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "el-dialog__wrapper",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.handleWrapperClick($event)
      }
    }
  }, [_c('div', {
    ref: "dialog",
    staticClass: "el-dialog",
    class: [_vm.sizeClass, _vm.customClass],
    style: (_vm.style)
  }, [_c('div', {
    staticClass: "el-dialog__header"
  }, [_vm._t("title", [_c('span', {
    staticClass: "el-dialog__title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), (_vm.showClose) ? _c('button', {
    staticClass: "el-dialog__headerbtn",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_c('i', {
    staticClass: "el-dialog__close el-icon el-icon-close"
  })]) : _vm._e()], 2), _vm._v(" "), (_vm.rendered) ? _c('div', {
    staticClass: "el-dialog__body"
  }, [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), (_vm.$slots.footer) ? _c('div', {
    staticClass: "el-dialog__footer"
  }, [_vm._t("footer")], 2) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-980aada6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/element-ui/packages/dialog/src/component.vue
// module id = 1086
// module chunks = 1